import { render, staticRenderFns } from "./shortButtons.vue?vue&type=template&id=5405566f&"
import script from "./shortButtons.vue?vue&type=script&lang=js&"
export * from "./shortButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5405566f')) {
      api.createRecord('5405566f', component.options)
    } else {
      api.reload('5405566f', component.options)
    }
    module.hot.accept("./shortButtons.vue?vue&type=template&id=5405566f&", function () {
      api.rerender('5405566f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shortButtons/shortButtons.vue"
export default component.exports